import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { Input } from 'react-rainbow-components';
import styled from 'styled-components';
import DollarSymbol from '../icons/DollarSymbol';
import getCentsFromDollars from '../../helpers/getCentsFromDollars';
import getDollarsFromCents from '../../helpers/getDollarsFromCents';
import isValidPriceAmount from '../../validators/isValidPriceAmount';

export const StyledIcon = styled(DollarSymbol)`
    color: ${(props) => props.theme.rainbow.palette.border.main};
`;
export default function PriceInputField(props) {
    const {
        className,
        style,
        name,
        label,
        labelAlignment,
        required,
        initialValue,
        bottomHelpText,
        disabled,
    } = props;

    return (
        <Field
            className={className}
            style={style}
            name={name}
            component={Input}
            type="number"
            min="0"
            label={label}
            labelAlignment={labelAlignment}
            icon={<StyledIcon />}
            iconPosition="right"
            bottomHelpText={bottomHelpText}
            required={required}
            parse={getCentsFromDollars}
            format={getDollarsFromCents}
            initialValue={initialValue}
            validate={isValidPriceAmount}
            disabled={disabled}
        />
    );
}

PriceInputField.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    name: PropTypes.string,
    label: PropTypes.string,
    labelAlignment: PropTypes.string,
    required: PropTypes.bool,
    initialValue: PropTypes.any,
    bottomHelpText: PropTypes.string,
    disabled: PropTypes.bool,
};

PriceInputField.defaultProps = {
    className: undefined,
    style: undefined,
    name: undefined,
    label: undefined,
    labelAlignment: 'left',
    required: false,
    initialValue: undefined,
    bottomHelpText: undefined,
    disabled: false,
};
